
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://kiwaauwhjypkikegymro.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imtpd2FhdXdoanlwa2lrZWd5bXJvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg1OTEzMDIsImV4cCI6MjA1NDE2NzMwMn0.YnOYyNlvRLSpRt7O_7PvyO9yGzSVQ3gWGhvXY7mAuog";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      storage: localStorage, // Use localStorage for better persistence
      detectSessionInUrl: true, // Detect session from URL for magic links
      flowType: 'pkce', // Use PKCE flow for better security
    },
    realtime: {
      params: {
        eventsPerSecond: 10,
      },
    },
    global: {
      // Fix TypeScript error by making this a proper rest parameter
      fetch: function(input: RequestInfo | URL, ...args: any[]) { 
        return fetch(input, args[0] || {}); 
      }
    },
  }
);
